import { Component } from '@angular/core';
import { MatLegacyDialog as MatLgDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'upsc-privacynotice',
  templateUrl: './privacynotice.component.html',
  styleUrls: ['./privacynotice.component.scss']
})
export class PrivacynoticeComponent {
  constructor(private dialogRef:MatDialogRef<PrivacynoticeComponent>){
 
  }
  public close() {
    this.dialogRef.close('close');
  }
}
